import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseCircleDashed: React.FC<CentralIconBaseProps> = (
  props,
) => {
  return (
    <CentralIconBase
      {...props}
      ariaLabel="close-circle-dashed, close, checkbox, remove"
    >
      <path
        d="M14.4141 21.7354L13.6748 21.8604C13.1298 21.9523 12.5702 22 12 22C11.4298 22 10.8702 21.9523 10.3252 21.8604L9.58594 21.7354L9.83496 20.2559L10.5742 20.3809C11.0372 20.459 11.5137 20.5 12 20.5C12.4863 20.5 12.9628 20.459 13.4258 20.3809L14.165 20.2559L14.4141 21.7354Z"
        fill="currentColor"
      />
      <path
        d="M5.06641 16.9189C5.62014 17.6979 6.30205 18.3799 7.08105 18.9336L7.69238 19.3682L6.82324 20.5908L6.21289 20.1562C5.297 19.5052 4.49478 18.703 3.84375 17.7871L3.40918 17.1768L4.63184 16.3076L5.06641 16.9189Z"
        fill="currentColor"
      />
      <path
        d="M20.5908 17.1768L20.1562 17.7871C19.5052 18.703 18.703 19.5052 17.7871 20.1562L17.1768 20.5908L16.3076 19.3682L16.9189 18.9336C17.6979 18.3799 18.3799 17.6979 18.9336 16.9189L19.3682 16.3076L20.5908 17.1768Z"
        fill="currentColor"
      />
      <path
        d="M16.0605 9L13.0605 12L16.0605 15L15 16.0605L12 13.0605L9 16.0605L7.93945 15L10.9395 12L7.93945 9L9 7.93945L12 10.9395L15 7.93945L16.0605 9Z"
        fill="currentColor"
      />
      <path
        d="M3.74414 9.83496L3.61914 10.5742C3.54102 11.0372 3.5 11.5137 3.5 12C3.5 12.4863 3.54102 12.9628 3.61914 13.4258L3.74414 14.165L2.26465 14.4141L2.13965 13.6748C2.04769 13.1298 2 12.5702 2 12C2 11.4298 2.04769 10.8702 2.13965 10.3252L2.26465 9.58594L3.74414 9.83496Z"
        fill="currentColor"
      />
      <path
        d="M21.8604 10.3252C21.9523 10.8702 22 11.4298 22 12C22 12.5702 21.9523 13.1298 21.8604 13.6748L21.7354 14.4141L20.2559 14.165L20.3809 13.4258C20.459 12.9628 20.5 12.4863 20.5 12C20.5 11.5137 20.459 11.0372 20.3809 10.5742L20.2559 9.83496L21.7354 9.58594L21.8604 10.3252Z"
        fill="currentColor"
      />
      <path
        d="M7.69238 4.63184L7.08105 5.06641C6.30205 5.62015 5.62014 6.30205 5.06641 7.08105L4.63184 7.69238L3.40918 6.82324L3.84375 6.21289C4.49478 5.297 5.297 4.49478 6.21289 3.84375L6.82324 3.40918L7.69238 4.63184Z"
        fill="currentColor"
      />
      <path
        d="M17.7871 3.84375C18.703 4.49478 19.5052 5.297 20.1562 6.21289L20.5908 6.82324L19.3682 7.69238L18.9336 7.08105C18.3799 6.30205 17.6979 5.62014 16.9189 5.06641L16.3076 4.63184L17.1768 3.40918L17.7871 3.84375Z"
        fill="currentColor"
      />
      <path
        d="M12 2C12.5702 2 13.1298 2.04769 13.6748 2.13965L14.4141 2.26465L14.165 3.74414L13.4258 3.61914C12.9628 3.54102 12.4863 3.5 12 3.5C11.5137 3.5 11.0372 3.54102 10.5742 3.61914L9.83496 3.74414L9.58594 2.26465L10.3252 2.13965C10.8702 2.04769 11.4298 2 12 2Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconCloseCircleDashed;
